import React from 'react';
import { MapPin, ChevronDown } from 'lucide-react';
export function Hero() {
  const scrollToServices = () => {
    const el = document.querySelector('#services');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden" data-id="element-87">
      {/* Background image */}
      <div className="absolute inset-0 bg-cover bg-center" style={{
      backgroundImage: `url('https://cdn.magicpatterns.com/uploads/jXC3M7BSBQyxv8PD3X1ekY/Screenshot_2026-07-10_104327.png')`
    }} aria-hidden="true" data-id="element-88" />
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-[#0d1117]/80" aria-hidden="true" data-id="element-89" />

      {/* Blue accent bar at bottom */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-[#2979ff]" aria-hidden="true" data-id="element-90" />

      {/* Content */}
      <div className="relative z-10 text-center px-4 sm:px-6 max-w-4xl mx-auto pt-20" data-id="element-91">
        {/* Logo */}
        <div className="flex justify-center mb-8" data-id="element-92">
          <img src="https://cdn.magicpatterns.com/uploads/iZx6wcW2kMqVcgUNkeyzh3/elitepoolz.jpg" alt="Elite Poolz" className="w-28 h-28 sm:w-36 sm:h-36 rounded-full object-cover border-4 border-[#2979ff] shadow-2xl shadow-[#2979ff]/30" data-id="element-93" />
        </div>

        <div className="flex items-center justify-center gap-2 mb-4 drop-shadow-[0_2px_8px_rgba(0,0,0,0.95)]" data-id="element-94">
          <MapPin size={16} className="text-[#2979ff]" data-id="element-95" />
          <span className="text-[#2979ff] text-sm font-semibold tracking-widest uppercase" data-id="element-96">
            Arizona
          </span>
        </div>

        <h1 className="text-4xl sm:text-6xl lg:text-7xl font-black tracking-tight mb-4 leading-none drop-shadow-[0_4px_14px_rgba(0,0,0,0.95)]" data-id="element-97">
          <span className="text-white" data-id="element-98">YOUR POOL.</span>
          <br data-id="element-99" />
          <span className="text-[#2979ff]" data-id="element-100">ELITE CLEAN.</span>
        </h1>

        <p className="text-gray-100 text-lg sm:text-xl max-w-2xl mx-auto mb-10 leading-relaxed drop-shadow-[0_2px_8px_rgba(0,0,0,0.95)]" data-id="element-101">
          Monthly service, repairs, tile cleans, acid washes, hardscape, grill
          cleaning, water features — everything your outdoor space deserves.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-102">
          <a href="#contact" onClick={e => {
          e.preventDefault();
          document.querySelector('#contact')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="bg-[#2979ff] hover:bg-[#1a5fd4] text-white font-bold px-8 py-4 rounded-xl text-lg transition-colors shadow-lg shadow-[#2979ff]/30" data-id="element-103">
            Get a Free Quote
          </a>
          <a href="#services" onClick={e => {
          e.preventDefault();
          document.querySelector('#services')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="border-2 border-white/30 hover:border-[#2979ff] text-white font-bold px-8 py-4 rounded-xl text-lg transition-colors" data-id="element-104">
            Our Services
          </a>
        </div>
      </div>

      {/* Scroll cue */}
      <button onClick={scrollToServices} className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/50 hover:text-[#2979ff] transition-colors animate-bounce" aria-label="Scroll down" data-id="element-105">
        <ChevronDown size={32} data-id="element-106" />
      </button>
    </section>;
}